import { render, staticRenderFns } from "./SplitItem.vue?vue&type=template&id=243bfec0&scoped=true"
import script from "./SplitItem.vue?vue&type=script&lang=js"
export * from "./SplitItem.vue?vue&type=script&lang=js"
import style0 from "./SplitItem.vue?vue&type=style&index=0&id=243bfec0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "243bfec0",
  null
  
)

export default component.exports